import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell';
import {countryRoutes} from '@modules/eu/country/country-routing.module';
import {physicianPharmacistGuard} from '@app/auth/guards/physician-pharmacist.guard';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'eu',
      canActivate: [physicianPharmacistGuard],
      children: countryRoutes,
    },
    {
      path: '**',
      redirectTo: '/',
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EURoutingModule {}
